import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupAccount } from "src/components/Shared/NewForms/NFLookupAccount";
import { NFLookupExpenseItem } from "src/components/Shared/NewForms/NFLookupExpenseItem";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFLookupUnit } from "src/components/Shared/NewForms/NFLookupUnit";
import { NFPlainNumber } from "src/components/Shared/NewForms/NFPlainNumber";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { VatTypeEnum } from "src/enums/VatTypeEnum";

export const WriteOffGoodsDetailProducts = () => {
  const tableName = "products";
  const { setValue, getValues } = useFormContext();
  const { t } = useTranslation();

  const handleVatTypeChanged = (newVatType: VatTypeEnum, index: number) => {
    // setValue(
    //     `${tableName}.${index}.vatAmount`,
    //     AmountHelper.getVatAmount(
    //         newVatType,
    //         getValues(`${tableName}.${index}.amount`),
    //         getValues("priceIncludesVat")
    //     )
    // );
  };

  const handleQuantityChanged = (newQuantity: number, index: number) => {
    // const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
    //     newQuantity,
    //     getValues(`${tableName}.${index}.price`),
    //     getValues(`${tableName}.${index}.vatType`),
    //     getValues("priceIncludesVat")
    // );
    // setValue(`${tableName}.${index}.amount`, newAmounts.amount);
    // setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
    // setValue(
    //     `${tableName}.${index}.amountWithVat`,
    //     newAmounts.amountWithVat
    // );
  };

  const handlePriceChanged = (newPrice: number, index: number) => {
    // const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
    //     getValues(`${tableName}.${index}.quantity`),
    //     newPrice,
    //     getValues(`${tableName}.${index}.vatType`),
    //     getValues("priceIncludesVat")
    // );
    // setValue(`${tableName}.${index}.amount`, newAmounts.amount);
    // setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
    // setValue(
    //     `${tableName}.${index}.amountWithVat`,
    //     newAmounts.amountWithVat
    // );
  };

  useEffect(() => {}, []);

  return (
    <>
      <div className={"panel-body tabs-menu-body main-content-body-right"}>
        <NFormTable fieldArray={tableName}>
          <NFPlainNumber fieldName={"lineNo"} title={t("#")} width={50} />
          <NFLookupProduct fieldName={"productId"} title={t("Product")} required={true} width={300} />
          <NFLookupUnit fieldName={"unitId"} title={t("Unit")} width={300} required={true} />
          <NFIntInput fieldName={"quantity"} title={t("Quantity")} onValueChanged={handleQuantityChanged} />
          {/*<NFIntInput*/}
          {/*    fieldName={"price"}*/}
          {/*    title={t("Price")}*/}
          {/*    onValueChanged={handlePriceChanged}*/}
          {/*/>*/}
          {/*<NFIntInput fieldName={"amount"} title={t("Amount")} />*/}
          <NFLookupExpenseItem fieldName={"expenseItemId"} title={t("ExpenseItem")} />
          <NFLookupAccount fieldName={"accountId"} title={t("Account")} />
        </NFormTable>
      </div>
    </>
  );
};
